const isDeploying =
    typeof process !== 'undefined' &&
    process.env?.DEPLOYING === 'YES'

let verbose = !isDeploying

let splitMessageLines = (msg: string): string[] => {
    const messages = msg.split('\n')
    if (messages.length === undefined) {
        return [msg]
    }
    return messages
}

export class Logger {
    static logObject(where: string, object: any) {
        this.logText(`object: [${where}]`)
        this.logText(JSON.stringify(object, null, 2))
    }

    static log(where: string, text: string) {
        this.logText(`[${where}] ${text}`)
    }

    static logSpecial(where: string, text: string) {
        this.logText(`[${where}] ${text}`)
    }

    static logImportant(where: string, text: string) {
        this.logText(`[${where}] ${text}`)
    }

    static logCritical(where: string, text: string) {
        this.logText(`[${where}] ${text}`, 'warn')
    }

    static logError(where: string, text: string) {
        let fullMessage = `[${where}] ${text}`
        let messages = splitMessageLines(fullMessage)
        for (let message of messages) {
            this.logText(message, 'error')
        }
    }

    private static logText(
        text: string,
        level: 'log' | 'warn' | 'error' = 'log'
    ) {
        if (!verbose) return
        console[level](text)
    }

    static censor(censor: any) {
        var i = 0;
        return function(key, value) {
            if(i !== 0 && typeof(censor) === 'object' && typeof(value) == 'object' && censor == value) 
            return '[Circular]'; 
        
            if(i >= 29) // seems to be a harded maximum of 30 serialized objects?
            return '[Unknown]';
        
            ++i; // so we know we aren't using the original object anymore
        
            return value;  
        }
    }
}
